import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from '../providers/auth/auth';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { StudiesPage } from '../pages/studies/studies';
import { PatientsPage } from '../pages/patients/patients';
import { PrescriptionsPage } from '../pages/prescriptions/prescriptions';
import { AdminClinicsPage } from '../pages/admin-clinics/admin-clinics';
import { AdminMedicationsPage } from '../pages/admin-medications/admin-medications';
import { AdminDoctorsPage } from '../pages/admin-doctors/admin-doctors';
import { AdminUsersPage } from '../pages/admin-users/admin-users';
import { AdminPrescriptionsPage } from '../pages/admin-prescriptions/admin-prescriptions';
import { AdminStudiesPage } from '../pages/admin-studies/admin-studies';
import { AdminClinicSwitchPage } from '../pages/admin-clinic-switch/admin-clinic-switch';
import { AdminUtilityPage } from '../pages/admin-utility/admin-utility';
import { PatientUploadPage } from '../pages/patient-upload/patient-upload';
import { AppVersion } from '@ionic-native/app-version';
import { AppConfig } from '../providers/config';
import { DatabaseProvider } from '../providers/database/database';
import { ClinicDoctorsPage } from '../pages/clinic-doctors/clinic-doctors';
import { ClinicMedicationsPage } from '../pages/clinic-medications/clinic-medications';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage:any = null;

  pages: Array<{title: string, component: any, badgecount: number}>;
  adminpages: Array<{title: string, component: any, badgecount: number}>;
  testerpages: Array<{title: string, component: any, badgecount: number}>; 

  versionnumber: any;
  enrolmentCount: any;

  userlanguage: string = 'en';

  constructor(
    public platform: Platform, 
    public statusBar: StatusBar, 
    public splashScreen: SplashScreen,
    public auth: AuthProvider,
    public translate: TranslateService,
    public appVersion: AppVersion,
    private readonly database: DatabaseProvider,
    private alertCtrl: AlertController
  ) {

    this.initializeApp();
    this.translate.setDefaultLang(this.userlanguage);

    if (this.platform.is("cordova")) {
      // You are on a device, cordova plugins are accessible
      this.appVersion.getVersionNumber().then(version => {
        console.log(version);
        this.versionnumber = version;
      });
    } else {
      // Cordova not accessible, add mock data if necessary
      this.versionnumber = AppConfig.constants.MOCK_VERSION;
      console.log("Cordova not accessible " + this.versionnumber);
    }

    // used for an example of ngFor and navigation
    if(this.userlanguage === 'en') {
      this.pages = [
        { title: 'Home', component: HomePage, badgecount: null },
        { title: 'Patients', component: PatientsPage, badgecount: null },
        { title: 'Prescriptions', component: PrescriptionsPage, badgecount: null },
        { title: 'Study Enrolments', component: StudiesPage, badgecount: null }
      ];
    }
    else {
      this.pages = [
        { title: 'Accueil', component: HomePage, badgecount: null },
        { title: 'Les patients', component: PatientsPage, badgecount: null },
        { title: 'Les ordonnances', component: PrescriptionsPage, badgecount: null },
        { title: 'Études d\'inscription', component: StudiesPage, badgecount: null }
      ];
    }
      this.testerpages = [
        { title: 'Clinics', component: AdminClinicsPage, badgecount: null },
        { title: 'Clinic Doctors', component: ClinicDoctorsPage, badgecount: null },
        { title: 'Clinic Medications', component: ClinicMedicationsPage, badgecount: null },
        // { title: 'Patient Upload', component: PatientUploadPage, badgecount: null },
        // { title: 'Clinic Switch', component: AdminClinicSwitchPage, badgecount: null  },
        { title: 'System Users', component: AdminUsersPage, badgecount: null },
        { title: 'Prescriptions Report', component: AdminPrescriptionsPage, badgecount: null },
        { title: 'Study Enrolments Report', component: AdminStudiesPage, badgecount: null },
      ];

      this.adminpages = [
        //{ title: 'Clinics', component: AdminClinicSwitchPage  },
        { title: 'Medications', component: AdminMedicationsPage, badgecount: null },
        // { title: 'Doctors', component: AdminDoctorsPage, badgecount: null },
        { title: 'Utilities', component: AdminUtilityPage, badgecount: null },
      ];
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this

      this.auth.getCurrentUser()
        .then(user => { 

          if (user) {
            this.rootPage = HomePage 
          } else {
            this.rootPage = LoginPage
          }
          this.statusBar.styleDefault();
          this.splashScreen.hide();
      })
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  async signOut() {
    await this.auth.logout();
    await this.nav.setRoot(LoginPage)
  }

  resetPassword() {
    this.auth.getCurrentUser()
        .then(user => { 
          if(user.email)  {

            let confirm = this.alertCtrl.create({
              title: "Reset Password",
              message:
                "Would you like to have Opteva Direct send you a password reset email?",
              buttons: [
                {
                  text: "No",
                  handler: () => {}
                },
                {
                  text: "Yes",
                  handler: () => {
                    this.auth.sendPasswordResetEmail(user.email)
                  }
                }
              ]
            });
            confirm.present();

           
          }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts